import React, { useEffect, useState } from 'react'
import { Button, PageHeader, Table, Space } from 'antd'
import { getProductFabrics } from '../../network/ProductFabrics'
import { useAuth } from '../../hooks/useAuth'
import { EyeOutlined } from '@ant-design/icons'

const ProductFabrics = ({ history }) => {
  const { user } = useAuth()
  const [productFabrics, setProductFabrics] = useState([])

  useEffect(() => {
    getProductFabrics()
      .then((data) => {
        const productPriceList = data.list.productFabric.products

        const productFabricArray = Object.entries(productPriceList).map(
          ([key, value]) => ({
            key,
            ...value,
          })
        )

        setProductFabrics(productFabricArray)
      })
      .catch((error) => {
        console.error('Failed to fetch product fabrics:', error)
      })
  }, [])

  const handleEdit = (product) => {
    history.push(`/product-fabric/${product.type}/${user.currentStore}`)
  }

  const columns = [
    {
      title: 'Product Name',
      dataIndex: 'label',
      key: 'label',
    },
    {
      title: 'Action',
      key: 'action',
      width: '50px',
      render: (text, product) => (
        <Space>
          <Button
            type="primary"
            shape="circle"
            icon={<EyeOutlined />}
            onClick={() => history.push(`/product-fabric/view/${product.type}`)}
          />
          <Button onClick={() => handleEdit(product)} type="primary">
            Add / Edit
          </Button>
        </Space>
      ),
    },
  ]

  return (
    <>
      <PageHeader className="site-page-header" title="Product Fabrics" />
      <Table
        columns={columns}
        dataSource={productFabrics}
        pagination={false}
        rowKey="key"
      />
    </>
  )
}

export default ProductFabrics
